import "./styles.scss";

import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

function CardWordoftheday({ level }) {
  const { t } = useTranslation();
  const { wordofthedayByDate } = useSelector((state) => state.contentReducer);

  const handleSelectColor = (level) => {
    if (level === "B1" || level === "B2") return "intermediateDiv";
    if (level === "C1" || level === "C2" || level === "DM") return "advancedDiv";

    return "basicDiv";
  };

  return (
    <div className="contentCardWordoftheday">
      <h4 className="title">{t("WORDOFTHEDAY")}</h4>
      <div className={`wordoftheDay ${handleSelectColor(level)}`}>
        {wordofthedayByDate?.words?.map((word) => (
          <a key={word.id} className={word.level} href={word?.externalLink} target="_blank" rel="noreferrer">
            <p>{word?.content}</p>
          </a>
        ))}
      </div>
    </div>
  );
}

export default CardWordoftheday;
